<template>
  <NuxtLayout>
    <Error404 v-if="error?.statusCode === 404" />
    <div v-else class="w-full md:p-32 md:pt-20 p-9 pt-5 flex justify-center">
      <span class="md:text-heading-3 text-mobile-heading-3 text-gray-1">
        {{ error?.message ?? "Some thing went wrong" }}
      </span>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const error = useError();
</script>
